module.exports = __webpack_public_path__ + "media/images/admin/icons/minimize-2-2e1032d6608649e8d33927df171d89df.svg";